<template>
  <div class="contanier">
    <el-container>
      <el-header>
        <headerVue @toggleSideBar="toggleSideBar" />
      </el-header>
      <el-container class="contanierBody">
        <el-aside class="aside" :class="{closeAside:!sidebar}">
          <asideVue @pushRouter="pushRouter" :sidebar="sidebar" :active="activeRouter" />
        </el-aside>
        <el-main>
          <div class="routerNav">
            <el-tabs 
              class="tab-menu"
              v-model="tabsValue"
            >
              <el-tab-pane 
                v-for="(d,i) in routerList" 
                :key="d.path" 
                :name="d.path"
                :label="d.name"
              >
              <span slot="label">
                <el-tag
                  class="tag"
                  :closable="d.path != '/home'"
                  :type="activeRouter == d.path ? 'success' :'info'"
                  size="small"
                  @click="tagPath(d)"
                  @close="handleClose(d,i)"
                >{{d.name}}</el-tag>
              </span>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="content">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import headerVue from '../../components/layOut/header.vue'
import asideVue from '../../components/layOut/aside.vue'
import router from '@/router/router'
export default {
  components: {
    headerVue,
    asideVue,
  },

  data() {
    return {
      routerList: [{ path: '/home', name: '首页' }],
      activeRouter: '',
      menuList: [],
      sidebar: true,
      tabsValue: '/home',
    }
  },
  created() {
    this.activeRouter = this.$router.currentRoute.path
    this.menuList = JSON.parse(sessionStorage.getItem('menuList'))
    const query = this.$route.query
    this.pushRouter({ path: this.activeRouter, query })
    this.tabsValue = this.activeRouter
  },
  watch: {
    $route(newRouter, oldRouter) {
      this.pushRouter({ path: newRouter.path, query: newRouter.query })
      this.tabsValue = newRouter.path
    },
  },
  methods: {
    handleClose(tag, i) {
      let row = this.routerList[i-1]
      if(tag.path == this.activeRouter){
        this.activeRouter = row.path
        this.$router.push({ path: row.path, query: row.query  })
      }
      this.routerList.splice(i, 1)
    },
    toggleSideBar(flag) {
      this.sidebar = flag
    },
    tagPath(row) {
      this.activeRouter = row.path
      this.$router.push({ path: row.path, query: row.query  })
    },
    pushRouter({ path: d, query }) {
      this.activeRouter = d
      let flag = false
      this.routerList.forEach((item) => {
        if (item.path == d) {
          item.query = query
          flag = true
        }
      })
      if (flag) {
        return
      }
      console.log(this.menuList, 'this.menuListthis.menuListthis.menuList--------------')
      this.menuList.forEach((ele) => {
        if ('/' + ele.path == d) {
          this.routerList.push({ path: d, name: ele.menuName, query })
        }
      })
    },
  },
  mounted() {
    // 获取所有的Cookie
  },
}
</script>


<style lang="less" scoped>
@import '../../assets/variables.less';

.tag {
  cursor: pointer;
}
.el-tag--small {
  margin-right: 10px;
}
.contanierBody {
  height: 859px;
  overflow: auto;
}
.contanier {
  display: flex;
  flex-direction: column;
  /* 垂直布局 */

  /* 让容器高度占据整个视口 */
}

.el-header {
  padding: 0;
  overflow: hidden;
  height: auto;
  height: 60px;
}

.el-aside {
  background-color: #ece4ce;
  color: #fff;
  text-align: center;
  line-height: 200px;
  width: auto !important;

  height: 859px;
}
.aside {
  width: 200px !important;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;
}
.closeAside {
  width: 40px !important;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;
}
.el-main {
  box-sizing: border-box;
  position: relative;
  background-color: #f2f6fc;
}

// .el-menu-vertical-demo:not(.el-menu--collapse) {
//   width: 200px;
//   height: 100%;
// }

.el-menu-vertical-demo {
  color: #fff;
  height: 100%;
}

.routerNav {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 5px 10px;
  box-sizing: border-box;
}

.content {
  margin-top: 30px;
}


/deep/ .tab-menu {
  .el-tabs__nav-next, .el-tabs__nav-prev{
    line-height: 24px;
  }
  .el-tabs__header{
    margin-bottom: 0;
  }
  .el-tabs__nav-wrap::after{
    display: none;
  }
  .el-tabs__active-bar{
    display: none;
  }
  .el-tabs__item{
    padding: 0;
    height: unset;
    line-height: normal;
  }
}

</style> 